import { render, staticRenderFns } from "./tooltip-secondary.vue?vue&type=template&id=0943d3e8&scoped=true"
import script from "./tooltip-secondary.vue?vue&type=script&lang=js"
export * from "./tooltip-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0943d3e8",
  null
  
)

export default component.exports